import React, { useState, useEffect } from 'react';
import Scrollspy from 'react-scrollspy';
import Flag from 'react-world-flags'
import { useDispatch, useStore } from 'react-redux'
import Icon from 'react-icons-kit';
import {facebookF} from 'react-icons-kit/fa/facebookF'

import { menu } from '../../utils/menu'
import { setLanguage } from '../../store/actions/changeLanguage'
import Tab from './Tab';

const Sidebar = () => {
  const dispatch = useDispatch()
  const store = useStore()

  const [active, setActive] = useState('intro')
  const [currentLanguage, setCurrentLanguage] = useState(store.getState().language.language )
  
  useEffect(() => store.subscribe(() => {
		const lang = store.getState().language.language
		setCurrentLanguage(lang)
  }), [store])

  return (
    <section id="sidebar">
      <div className="inner">
        <nav>
          <ul className="languageSelector">
            {
              menu.getAllLanguages().map(language => (
                <li
                  key={language.key}
                  onClick={() => dispatch(setLanguage(language.slug))}
                  tabIndex={-1}
                  role="button"
                  onKeyDown={null}
                >
                  <Flag height="16" code={language.iso} />
                  <span>
                    {language[currentLanguage]}
                  </span>
                </li>
              ))
            }
          </ul>
        </nav>
        <nav className="mainNav">
          <Scrollspy
            items={menu.getSideMenu()[currentLanguage].map(s => s.target)}
            currentClassName="active"
            offset={-300}
            onUpdate={e => setActive(e.id)}
          >
            <li
              className="facebook-link"
              onClick={() => window.open('https://www.facebook.com/events/1915632191914309/?notif_t=plan_user_invited&notif_id=1583004055035698', '_blank')}
            >
              <div
                style={{
                  color: '#b74e91'
                }}
              >
                <Icon icon={facebookF} size="2em" />
              </div>
            </li>
            {
              menu.getSideMenu()[currentLanguage].map(tab => 
                <Tab key={tab.id} isActive={tab.target === active ? 'active' : null} target={tab.target} label={tab.label} />
              )
            }
          </Scrollspy>
        </nav>
      </div>
    </section>
  );
}

export default Sidebar;
